import React from 'react'

function BackToTop() {
  return (
    <a href="#" className="btn btn-lg btn-secondary btn-lg-square back-to-top"><i className="bi bi-arrow-up" /></a>
  )
}

export default BackToTop